"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7401],{

/***/ 76291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wm": function() { return /* reexport */ DirectoryComponent; },
  "it": function() { return /* reexport */ DirectoryEmptyStateComponent; },
  "bS": function() { return /* reexport */ DirectoryHeaderComponent; }
});

// UNUSED EXPORTS: DirectoryHeaderContentComponent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/thumbnails-types.js
var thumbnails_types = __webpack_require__(50432);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/directory/directory-empty-state/directory-empty-state-component.scss.js

var StyledDirectoryEmptyStateComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1aqzayr0"
})("display:flex;flex-direction:column;align-items:center;width:100%;text-align:center;margin-top:32px;.empty-state-title{font-size:1.75rem;font-weight:400;margin-bottom:8px;}.empty-state-subtitle{font-size:0.875rem;line-height:24px;width:360px;}");

;// CONCATENATED MODULE: ./components/core/directory/directory-empty-state/directory-empty-state-component.js







var DirectoryEmptyStateComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryEmptyStateComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryEmptyStateComponent);
    function DirectoryEmptyStateComponent() {
        (0,_class_call_check/* default */.Z)(this, DirectoryEmptyStateComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DirectoryEmptyStateComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryEmptyStateComponent, {
                    className: "directory-empty-state-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "empty-state-image-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/static/img/empty-states/clouds-empty-state.png"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "empty-state-title",
                            children: "No results were found"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "empty-state-subtitle",
                            children: "What you are looking for is not being found, check your spelling of use a different word"
                        })
                    ]
                });
            }
        }
    ]);
    return DirectoryEmptyStateComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/lists/base-list/base-list-component.js







var BaseListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseListComponent);
    function BaseListComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseListComponent);
        var _this;
        _this = _super.call(this, props);
        _this.itemRenderer = _this.itemRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseListComponent, [
        {
            key: "hasFilter",
            value: function hasFilter() {
                var _props = this.props, filterTerm = _props.filterTerm, filterValidator = _props.filterValidator;
                return filterTerm && filterTerm != "" && filterValidator;
            }
        },
        {
            key: "filterItems",
            value: function filterItems() {
                var _props = this.props, listData = _props.listData, filterValidator = _props.filterValidator;
                var filteredItems = [];
                listData.forEach(function(item) {
                    if (filterValidator(item)) {
                        filteredItems.push(item);
                    }
                });
                return filteredItems;
            }
        },
        {
            key: "getFilteredItems",
            value: function getFilteredItems() {
                var listData = this.props.listData;
                var filteredItems = this.hasFilter() ? this.filterItems() : listData;
                return filteredItems || [];
            }
        },
        {
            key: "itemRenderer",
            value: function itemRenderer(item) {
                var itemRenderer1 = this.props.itemRenderer;
                return itemRenderer1 ? itemRenderer1(item) : item;
            }
        },
        {
            key: "renderEmptyState",
            value: function renderEmptyState() {
                var emptyStateRenderer = this.props.emptyStateRenderer;
                return emptyStateRenderer ? emptyStateRenderer() : "";
            }
        },
        {
            key: "renderItems",
            value: function renderItems(items) {
                return items.map(this.itemRenderer);
            }
        },
        {
            key: "render",
            value: function render() {
                var items = this.getFilteredItems();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: items.length > 0 ? this.renderItems(items) : this.renderEmptyState()
                });
            }
        }
    ]);
    return BaseListComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./components/core/thumbnails/background-color-thumbnail-item/read-more/read-more-component.scss.js


var StyledReadMoreComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14x5hig0"
})("background:rgba(#333,0.4);height:66px;width:100%;display:flex;justify-content:center;flex-direction:column;position:absolute;bottom:0;text-align:center;font-size:1.181rem;color:", colors/* default.white */.Z.white, ";");

;// CONCATENATED MODULE: ./components/core/thumbnails/background-color-thumbnail-item/read-more/read-more-component.js







var ReadMoreComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ReadMoreComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ReadMoreComponent);
    function ReadMoreComponent() {
        (0,_class_call_check/* default */.Z)(this, ReadMoreComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ReadMoreComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledReadMoreComponent, {
                    className: "read-more-component",
                    children: "Read More >"
                });
            }
        }
    ]);
    return ReadMoreComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/thumbnails/background-color-thumbnail-item/background-color-thumbnail-item-component.scss.js


var StyledBackgroundColorThumbnailItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "erd7mjl0"
})("background:green;position:relative;height:350px;width:300px;margin:20px;transition:0.2s ease-in-out all;text-decoration:none;&:hover{transform:scale(1.03);cursor:pointer;}.thumbnail-title{color:", colors/* default.white */.Z.white, ";font-size:1.688rem;padding:30px;}");

;// CONCATENATED MODULE: ./components/core/thumbnails/background-color-thumbnail-item/background-color-thumbnail-item-component.js









var BackgroundColorThumbnailItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BackgroundColorThumbnailItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BackgroundColorThumbnailItemComponent);
    function BackgroundColorThumbnailItemComponent() {
        (0,_class_call_check/* default */.Z)(this, BackgroundColorThumbnailItemComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BackgroundColorThumbnailItemComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, link = _props.link, color = _props.color;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBackgroundColorThumbnailItemComponent, {
                    href: link,
                    className: "background-color-thumbnail-item-component",
                    style: {
                        backgroundColor: colors/* default */.Z[color]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "thumbnail-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreComponent, {})
                    ]
                });
            }
        }
    ]);
    return BackgroundColorThumbnailItemComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./components/core/thumbnails/background-image-thumbnail-item/background-image-thumbnail-item-component.scss.js


var thumbnailHeight = "320px";
var imageHeight = "240px";
var textBaseHeight = "calc(".concat(thumbnailHeight, " - ").concat(imageHeight, ")");
var StyledBackgroundImageThumbnailItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "ep0z2cj0"
})("position:relative;height:320px;width:300px;overflow:hidden;margin:20px;border-radius:4px;background-color:", colors/* default.white */.Z.white, ";transition:0.2s ease-in-out all;text-decoration:none;cursor:pointer;.image-container{height:", imageHeight, ";opacity:1;width:100%;transition:0.2s opacity ease;}.hover-decorator-container{display:none;position:absolute;right:16px;top:16px;font-size:1rem;font-weight:400;color:", colors/* default.black */.Z.black, ";}.text-container{position:absolute;bottom:0;height:", textBaseHeight, ";overflow:hidden;padding:0 24px;transition:0.2s height ease;color:", colors/* default.black */.Z.black, ";background-color:", colors/* default.white */.Z.white, ";.thumbnail-title-wrapper{height:100%;width:252px;display:flex;flex-wrap:wrap;align-items:center;align-content:center;margin-bottom:8px;.thumbnail-title{font-size:1.375rem;width:100%;line-height:1.4;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}.thumbnail-title-decorator{color:", colors/* default.brand-gray */.Z["brand-gray"], ";font-size:0.875rem;}}.thumbnail-subtitle{display:flex;font-size:0.8125rem;line-height:20px;margin-bottom:8px;}.buttom-link-container{font-size:0.8125rem;color:", colors/* default.light-blue */.Z["light-blue"], ";text-decoration:underline;}}&:hover{.image-container{opacity:0.5;}.hover-decorator-container{display:block;}.text-container{height:120px;padding:0 24px;display:flex;flex-direction:column;justify-content:center;.thumbnail-title-wrapper{height:auto;}}&.extended-hover-height{.text-container{height:160px;}}}");

;// CONCATENATED MODULE: ./components/core/thumbnails/background-image-thumbnail-item/background-image-thumbnail-item-component.js





function background_image_thumbnail_item_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var BackgroundImageThumbnailItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BackgroundImageThumbnailItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BackgroundImageThumbnailItemComponent);
    function BackgroundImageThumbnailItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BackgroundImageThumbnailItemComponent);
        var _this;
        _this = _super.call(this, props);
        background_image_thumbnail_item_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "itemClicked", function() {
            var link = _this.props.link;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.THUMBNAIL_LIST_LINK_CLICKED, {
                kind: link
            });
        });
        _this.onButtomLinkClick = _this.onButtomLinkClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BackgroundImageThumbnailItemComponent, [
        {
            key: "onButtomLinkClick",
            value: function onButtomLinkClick(e) {
                var buttomLink = this.props.buttomLink;
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.THUMBNAIL_LIST_BOTTOM_LINK_CLICKED, {
                    kind: buttomLink
                });
                e.stopPropagation();
                e.preventDefault();
                window.location.href = buttomLink.url;
            }
        },
        {
            key: "shouldShowHoverDecorator",
            value: function shouldShowHoverDecorator() {
                var hoverDecorator = this.props.hoverDecorator;
                return hoverDecorator && hoverDecorator.show;
            }
        },
        {
            key: "shouldShowButtomLink",
            value: function shouldShowButtomLink() {
                var buttomLink = this.props.buttomLink;
                return buttomLink && buttomLink.show;
            }
        },
        {
            key: "shouldShowSecondTitle",
            value: function shouldShowSecondTitle() {
                var secondTitle = this.props.secondTitle;
                return secondTitle && secondTitle.text && secondTitle.text.length > 0;
            }
        },
        {
            key: "renderTitle",
            value: function renderTitle(title) {
                var text = title.text, decorator = title.decorator;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "thumbnail-title",
                    children: [
                        text,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "thumbnail-title-decorator",
                            children: decorator
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, link = _props.link, firstTitle = _props.firstTitle, secondTitle = _props.secondTitle, subtitle = _props.subtitle, buttomLink = _props.buttomLink, image = _props.image, hoverDecorator = _props.hoverDecorator;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBackgroundImageThumbnailItemComponent, {
                    className: classnames_default()("background-image-thumbnail-item-component", {
                        "extended-hover-height": this.shouldShowSecondTitle()
                    }),
                    href: link,
                    target: "_blank",
                    onClick: this.itemClicked,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "image-container",
                            src: image,
                            extraCloudinaryTransformations: {
                                width: 400
                            }
                        }),
                        this.shouldShowHoverDecorator() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hover-decorator-container",
                            children: hoverDecorator.text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "thumbnail-title-wrapper",
                                    children: [
                                        this.renderTitle(firstTitle),
                                        this.shouldShowSecondTitle() && this.renderTitle(secondTitle)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "thumbnail-subtitle",
                                    children: subtitle
                                }),
                                this.shouldShowButtomLink() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "buttom-link-container",
                                    onClick: this.onButtomLinkClick,
                                    style: {
                                        color: colors/* default */.Z[buttomLink.color]
                                    },
                                    children: buttomLink.text
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return BackgroundImageThumbnailItemComponent;
}(react.PureComponent);

BackgroundImageThumbnailItemComponent.defaultProps = {
    firstTitle: {}
};

;// CONCATENATED MODULE: ./components/core/thumbnails/base-thumbnail-item/base-thumbnail-item-component.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}





var _obj;
var THUMBNAILS_TYPE_TO_COMPONENT_MAPPING = (_obj = {}, (0,_define_property/* default */.Z)(_obj, thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_COLOR */.H.BACKGROUND_COLOR, BackgroundColorThumbnailItemComponent), (0,_define_property/* default */.Z)(_obj, thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_IMAGE */.H.BACKGROUND_IMAGE, BackgroundImageThumbnailItemComponent), _obj);
var BaseThumbnailItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseThumbnailItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseThumbnailItemComponent);
    function BaseThumbnailItemComponent() {
        (0,_class_call_check/* default */.Z)(this, BaseThumbnailItemComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BaseThumbnailItemComponent, [
        {
            key: "mapThumbnailTypeToComponent",
            value: function mapThumbnailTypeToComponent() {
                var thumbnailType = this.props.thumbnailType;
                return THUMBNAILS_TYPE_TO_COMPONENT_MAPPING[thumbnailType];
            }
        },
        {
            key: "render",
            value: function render() {
                var ThumbnailComponent = this.mapThumbnailTypeToComponent();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailComponent, _object_spread({}, this.props));
            }
        }
    ]);
    return BaseThumbnailItemComponent;
}(react.PureComponent);

BaseThumbnailItemComponent.defaultProps = {
    thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_COLOR */.H.BACKGROUND_COLOR
};

;// CONCATENATED MODULE: ./components/core/lists/thumbnails-list/thumbnails-list-component.scss.js

var StyledThumbnailsListComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e131b5ci0"
})("display:flex;flex-wrap:wrap;justify-content:center;margin-left:20px;margin-right:20px;max-width:1400px;margin:auto;margin-bottom:70px;");

;// CONCATENATED MODULE: ./components/core/lists/thumbnails-list/thumbnails-list-component.js





function thumbnails_list_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function thumbnails_list_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            thumbnails_list_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var ThumbnailsListComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ThumbnailsListComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ThumbnailsListComponent);
    function ThumbnailsListComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ThumbnailsListComponent);
        var _this;
        _this = _super.call(this, props);
        _this.filterValidator = _this.filterValidator.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.thumbnailRenderer = _this.thumbnailRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ThumbnailsListComponent, [
        {
            key: "getItemFilterValue",
            value: function getItemFilterValue(thumbnailData) {
                return thumbnailData.props.title || "";
            }
        },
        {
            key: "filterValidator",
            value: function filterValidator(item) {
                var _props = this.props, filterTerm = _props.filterTerm, filterValidator1 = _props.filterValidator;
                if (filterValidator1) {
                    return filterValidator1(item);
                }
                var itemValue = this.getItemFilterValue(item);
                return itemValue.toLowerCase().indexOf(filterTerm.toLowerCase()) !== -1;
            }
        },
        {
            key: "thumbnailRenderer",
            value: function thumbnailRenderer(thumbnailData) {
                var thumbnailType = this.props.thumbnailType;
                var link = thumbnailData.props.link;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseThumbnailItemComponent, thumbnails_list_component_object_spread({
                    thumbnailType: thumbnailType
                }, thumbnailData.props), "".concat(link, "_").concat(thumbnailData.props.title));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, tuhmbnailsListData = _props.tuhmbnailsListData, filterTerm = _props.filterTerm, emptyStateRenderer = _props.emptyStateRenderer;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThumbnailsListComponent, {
                    className: "thumbnails-list-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseListComponent, {
                        filterTerm: filterTerm,
                        filterValidator: this.filterValidator,
                        listData: tuhmbnailsListData,
                        itemRenderer: this.thumbnailRenderer,
                        emptyStateRenderer: emptyStateRenderer
                    })
                });
            }
        }
    ]);
    return ThumbnailsListComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js + 1 modules
var signup_with_text_component = __webpack_require__(77385);
;// CONCATENATED MODULE: ./components/core/directory/directory-component/directory-component.scss.js


var StyledDirectoryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ggmpg0"
})("width:100%;.directory-signup-wrapper{display:flex;justify-content:center;background-color:", colors/* default.white */.Z.white, ";padding:64px;}");

;// CONCATENATED MODULE: ./components/core/directory/directory-component/directory-component.js













var DirectoryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryComponent);
    function DirectoryComponent(props) {
        (0,_class_call_check/* default */.Z)(this, DirectoryComponent);
        var _this;
        _this = _super.call(this, props);
        _this.emptyStateRenderer = _this.emptyStateRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(DirectoryComponent, [
        {
            key: "emptyStateRenderer",
            value: function emptyStateRenderer() {
                var emptyStateRenderer1 = this.props.emptyStateRenderer;
                return emptyStateRenderer1 ? emptyStateRenderer1() : /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryEmptyStateComponent, {});
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, tuhmbnailsListData = _props.tuhmbnailsListData, backgroundColor = _props.backgroundColor, thumbnailType = _props.thumbnailType, filterTerm = _props.filterTerm, signupForm = _props.signupForm, filterValidator = _props.filterValidator;
                var listData = tuhmbnailsListData.map(function(item) {
                    return item.props;
                });
                var allowSignupForm = signupForm && signupForm.show;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDirectoryComponent, {
                    className: "directory-component",
                    style: {
                        backgroundColor: backgroundColor
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "directory-list-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbnailsListComponent, {
                                filterTerm: filterTerm,
                                tuhmbnailsListData: tuhmbnailsListData,
                                thumbnailType: thumbnailType,
                                emptyStateRenderer: this.emptyStateRenderer,
                                filterValidator: filterValidator
                            })
                        }),
                        allowSignupForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "directory-signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, {
                                title: signupForm.title,
                                subtitle: signupForm.subtitle
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return DirectoryComponent;
}(react.PureComponent);

DirectoryComponent.defaultProps = {
    tuhmbnailsListData: [],
    thumbnailType: thumbnails_types/* THUMBNAILS_TYPES.BACKGROUND_COLOR */.H.BACKGROUND_COLOR,
    backgroundColor: colors/* default.light-grey */.Z["light-grey"],
    signupForm: {
        show: true,
        title: "Start using monday.com today",
        subtitle: "Try it now for free / No credit card needed"
    }
};

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/enhancements/decorators/hotdog-header/hotdog-header-component.scss.js


var StyledHotdogHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mqafle0"
})('position:relative;width:100vw;.hotdog{content:"";width:132vw;height:132vw;position:absolute;bottom:0;left:-16vw;z-index:0;border-radius:50%;@media (max-width:', vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){width:136vw;height:136vw;left:-18vw;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:220vw;height:220vw;left:-60vw;}}");

;// CONCATENATED MODULE: ./components/enhancements/decorators/hotdog-header/hotdog-header-component.js








var HotdogHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HotdogHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HotdogHeaderComponent);
    function HotdogHeaderComponent() {
        (0,_class_call_check/* default */.Z)(this, HotdogHeaderComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HotdogHeaderComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, className = _props.className, backgroundColor = _props.backgroundColor, containerHeight = _props.containerHeight, containerMinHeight = _props.containerMinHeight, hotdogColor = _props.hotdogColor, children = _props.children;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHotdogHeaderComponent, {
                    className: "hotdog-header-component ".concat(className),
                    style: {
                        height: containerHeight,
                        minHeight: containerMinHeight,
                        backgroundColor: colors/* default */.Z[backgroundColor]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hotdog",
                            style: {
                                backgroundColor: colors/* default */.Z[hotdogColor]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "children-wrapper",
                            children: children
                        })
                    ]
                });
            }
        }
    ]);
    return HotdogHeaderComponent;
}(react.PureComponent);

HotdogHeaderComponent.defaultProps = {
    containerHeight: "48vh"
};

;// CONCATENATED MODULE: ./static/svg/icons/search.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgSearch = function SvgSearch(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        viewBox: "0 0 23 23"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#E1E1E1",
        strokeLinejoin: "round",
        strokeWidth: 2,
        transform: "translate(1 1)"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: 8.5,
        cy: 8.5,
        r: 8
    }), /*#__PURE__*/ react.createElement("path", {
        strokeLinecap: "round",
        d: "M14.156 14.156 21 21"
    }))));
};
/* harmony default export */ var search = (SvgSearch);

;// CONCATENATED MODULE: ./components/core/directory/directory-header-content/directory-header-content-component.scss.js



var StylesDirectoryHeaderContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg8ooxo0"
})("position:absolute;left:0;right:0;top:0;bottom:0;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;h1{max-width:60vw;font-size:4vw;font-weight:400;color:", colors/* default.white */.Z.white, ";margin-bottom:24px;letter-spacing:1.3px;max-width:50vw;}h2{max-width:60vw;font-size:1.3vw;line-height:34px;font-weight:100;letter-spacing:1.3px;color:", colors/* default.white */.Z.white, ";margin-bottom:24px;max-width:50vw;}.search-input-wrapper{position:relative;height:40px;width:300px;input{height:100%;width:100%;padding:0 48px 0 16px;border-radius:24px;outline:none;border:0;font-size:0.8125rem;}.search-icon-container{position:absolute;pointer-events:none;right:16px;top:50%;transform:translateY(-50%);}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){h1{font-size:2.25rem;max-width:100vw;}h2{font-size:1rem;max-width:100vw;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){h1{font-size:3.375rem;max-width:100%;padding:0 16px;}h2{max-width:100%;padding:0 16px;}}");

;// CONCATENATED MODULE: ./components/core/directory/directory-header-content/directory-header-content-component.js










var DirectoryHeaderContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryHeaderContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryHeaderContentComponent);
    function DirectoryHeaderContentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, DirectoryHeaderContentComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onInputChange = _this.onInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(DirectoryHeaderContentComponent, [
        {
            key: "shouldShowSearch",
            value: function shouldShowSearch() {
                var searchConfig = this.props.searchConfig;
                return searchConfig && searchConfig.show;
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(event) {
                var onSearchChange = this.props.onSearchChange;
                var value = event.target.value;
                return onSearchChange(value);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, textColor = _props.textColor, searchConfig = _props.searchConfig, searchValue = _props.searchValue, onSearchChange = _props.onSearchChange;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StylesDirectoryHeaderContentComponent, {
                    className: "directory-header-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            dangerouslySetInnerHTML: {
                                __html: title
                            },
                            style: {
                                color: colors/* default */.Z[textColor]
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            },
                            style: {
                                color: colors/* default */.Z[textColor]
                            }
                        }),
                        this.shouldShowSearch() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search-input-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: searchConfig.placeholder,
                                    value: searchValue || "",
                                    onChange: this.onInputChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {})
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return DirectoryHeaderContentComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/directory/directory-header/directory-header-component.scss.js


var StyledDirectoryHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1j7hod90"
})(".directory-header-component{.image-container{position:absolute;left:0;top:-65px;width:30vw;img{width:100%;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.directory-header-component{height:30vh;img{display:none;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.directory-header-component{height:60vh;min-height:460px;}}");

;// CONCATENATED MODULE: ./components/core/directory/directory-header/directory-header-component.js









var DirectoryHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DirectoryHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DirectoryHeaderComponent);
    function DirectoryHeaderComponent() {
        (0,_class_call_check/* default */.Z)(this, DirectoryHeaderComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DirectoryHeaderComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, hotDogColor = _props.hotDogColor, textColor = _props.textColor, title = _props.title, subtitle = _props.subtitle, searchConfig = _props.searchConfig, searchValue = _props.searchValue, onSearchChange = _props.onSearchChange, img = _props.img;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDirectoryHeaderComponent, {
                    className: "directory-header-component-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HotdogHeaderComponent, {
                        className: "directory-header-component",
                        backgroundColor: "light-grey",
                        hotdogColor: hotDogColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: img
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectoryHeaderContentComponent, {
                                title: title,
                                subtitle: subtitle,
                                textColor: textColor,
                                searchConfig: searchConfig,
                                searchValue: searchValue,
                                onSearchChange: onSearchChange
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return DirectoryHeaderComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/directory/index.js






/***/ }),

/***/ 77385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupWithTextComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.scss.js


var StyledSignupWithTextComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewvr9040"
})("width:100%;position:relative;.signup-form-title{text-align:center;margin-bottom:24px;h1{font-weight:500;}}&.with-subtitle{.signup-form-title{margin-bottom:8px;}}&.text-under-buttons{.signup-form-subtitle{margin-bottom:0;margin-top:24px;}}.signup-form-subtitle{text-align:center;h2{font-weight:300;}margin-bottom:24px;}.error-tooltip-text{color:red;font-weight:300;}.tooltip{transform:translate(10%,-120%);}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.tooltip{transform:translate(5%,-120%);}}");

;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SignupWithTextComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupWithTextComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupWithTextComponent);
    function SignupWithTextComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SignupWithTextComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(SignupWithTextComponent, [
        {
            key: "renderTexts",
            value: function renderTexts() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "signup-texts",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: title
                            })
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-subtitle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: subtitle
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "renderForm",
            value: function renderForm() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({}, this.props));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, subtitle = _props.subtitle, textUnderButtons = _props.textUnderButtons;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupWithTextComponent, {
                    className: classnames_default()("signup-form-wrapper", {
                        "with-subtitle": subtitle,
                        "text-under-buttons": textUnderButtons
                    }),
                    children: [
                        textUnderButtons ? this.renderForm() : this.renderTexts(),
                        textUnderButtons ? this.renderTexts() : this.renderForm()
                    ]
                });
            }
        }
    ]);
    return SignupWithTextComponent;
}(react.PureComponent);

SignupWithTextComponent.defaultProps = {
    textUnderButtons: false
};


/***/ }),

/***/ 50432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ THUMBNAILS_TYPES; }
/* harmony export */ });
var THUMBNAILS_TYPES = {
    BACKGROUND_COLOR: "BACKGROUND_COLOR",
    BACKGROUND_IMAGE: "BACKGROUND_IMAGE"
};


/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 37221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ itemFilterValidator; }
/* harmony export */ });
var isTextMatchTerm = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", term = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return text.toLowerCase().trim().indexOf(term.toLowerCase().trim()) !== -1;
};
var isTitleLineMatchTerm = function(titleLine, term) {
    if (!titleLine || !titleLine.text) {
        return false;
    }
    return isTextMatchTerm(titleLine.text, term) || isTextMatchTerm(titleLine.decorator, term);
};
var itemFilterValidator = function(item, term) {
    var _props = item.props, firstTitle = _props.firstTitle, secondTitle = _props.secondTitle;
    return isTitleLineMatchTerm(firstTitle, term) || isTitleLineMatchTerm(secondTitle, term);
};


/***/ })

}]);